module.exports = __webpack_public_path__ + "img/student-testimonial-01.4429c706.jpg";